import instance from 'services/api';
import { toast } from 'react-toastify';
import {
  SET_LOADING_TO,
  GET_EMPLOYEE_TO,
  ADD_EMPLOYEE_TO,
  LAST_CREATED_EMPLOYEE_TO,
  DELETE_EMPLOYEE_TO,
  UPDATE_EMPLOYEE_TO,
} from '../types';

export const getEmployeesOrderingTO = (uuid) => (dispatch, getState) => {
  const lastCreatedEmployeesId = getState().tableOrdering.lastCreatedEmployee;
  dispatch({ type: SET_LOADING_TO, payload: true });
  return instance
    .get(`/cloud-pos/employee`, {
      headers: {
        businessUuid: uuid,
      },
    })
    .then((response) => {
      const data = response?.data?.data;
      if (lastCreatedEmployeesId) {
        const index = data.findIndex((employee) => employee?._id === lastCreatedEmployeesId);
        if (index !== -1) {
          const [lastCreatedEmployees] = data.splice(index, 1);
          data.unshift(lastCreatedEmployees);
        }
      }
      dispatch({ type: GET_EMPLOYEE_TO, payload: data });
      dispatch({ type: SET_LOADING_TO, payload: false });
      return data;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING_TO, payload: false });
      return Promise.reject(err);
    });
};

export const createEmployeesTO = (body, uuid) => (dispatch, getState) => {
  const employees = getState().tableOrdering.employees;
  dispatch({ type: SET_LOADING_TO, payload: true });
  return instance
    .post(`/cloud-pos/employee`, body)
    .then((response) => {
      const data = response?.data?.data;
      const lastCreatedEmployeesId = response?.data?.data?._id || null;
      const filterEmployees = employees.filter((employee) => employee?._id !== data?._id);
      filterEmployees.push(data);
      dispatch({ type: ADD_EMPLOYEE_TO, payload: filterEmployees || [] });
      dispatch({ type: LAST_CREATED_EMPLOYEE_TO, payload: lastCreatedEmployeesId });
      dispatch({ type: SET_LOADING_TO, payload: false });
      dispatch(getEmployeesOrderingTO(uuid));
      return data;
    })
    .catch((err) => {
      if (err?.response?.data?.message && err?.response?.data?.message?.message) {
        const errorMessage = Array.isArray(err?.response?.data?.message?.message)
          ? err?.response?.data?.message?.message[0]
          : err?.response?.data?.message?.message;
        toast.error(errorMessage || 'Something went wrong!');
      }
      dispatch({ type: SET_LOADING_TO, payload: false });
      return Promise.reject(err);
    });
};

export const deleteEmployeesTO = (employeesId, uuid) => (dispatch, getState) => {
  const employees = getState().tableOrdering.employees;
  dispatch({ type: SET_LOADING_TO, payload: true });
  return instance
    .delete(`/cloud-pos/employee/${employeesId}`)
    .then(() => {
      const filterEmployees = employees.filter((employee) => employee?._id !== employeesId);
      dispatch({ type: DELETE_EMPLOYEE_TO, payload: filterEmployees });
      dispatch({ type: SET_LOADING_TO, payload: false });
      dispatch(getEmployeesOrderingTO(uuid));
      return filterEmployees;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING_TO, payload: false });
      return Promise.reject(err);
    });
};

export const updateEmployeesTO = (dataReq, employeeId, uuid) => async (dispatch, getState) => {
  const employees = getState().tableOrdering.employees;
  dispatch({ type: SET_LOADING_TO, payload: true });
  try {
    const response = await instance
      .patch(`/cloud-pos/employee/${employeeId}`, dataReq);
    console.log(response, 'eresponse');
    const data = response?.data?.data;
    const findIndex = employees.findIndex((employee) => {
      return employee._id === employeeId;
    });
    if (findIndex !== -1) {
      employees[findIndex] = data;
    }
    dispatch({ type: UPDATE_EMPLOYEE_TO, payload: employees || [] });
    toast.success('Employee has been update  successfully!');
    dispatch({ type: SET_LOADING_TO, payload: false });
    dispatch(getEmployeesOrderingTO(uuid));
    return data;
  } catch (err) {
    if (err?.response?.data?.message && err?.response?.data?.message?.message) {
      const errorMessage = Array.isArray(err?.response?.data?.message?.message)
        ? err?.response?.data?.message?.message[0]
        : err?.response?.data?.message?.message;
      toast.error(errorMessage || 'Something went wrong!');
    }
    dispatch({ type: SET_LOADING_TO, payload: false });
    return await Promise.reject(err);
  }
};
